<template>
  <div>home</div>
</template>

<script>
import { getRedis } from "../../libs/api";
import { Indicator } from "mint-ui";
export default {
  name: "Home",
  metaInfo() {
    return {
      title: this.pageName,
    };
  },
  data() {
    return {
      pageName: "新东方专题活动",
      filterNum: "", // 1: 学校 2: 年级  3: 时间
      schoolName: "", // 校区名字
      gradeName: "", // 年级名字
      subjectName: "", // 科目名字
      timeName: "", // 时间名字
      selectSchoolId: "", // 选中的学校Id
      selectGradeId: "", // 选中的校区Id
      selectSubjectId: "", // 科目Id
      selectTimeId: "", // 选中的时间Id
      activityId: "", // 活动Id
      channelId: "", // 渠道Id
      selectNavString: "", // 选择学校0，时间1，科目2，显示时间栏
      pageId: "", // 页面Id 1: 套餐 2: 单页 3: 报赠
    };
  },
  created() {},
  mounted() {
    Indicator.open({
      text: "加载中...",
      spinnerType: "fading-circle",
    });
    let queryParams = this.$route.query;
    // 获取标题参数
    // console.log('获取参数', packageTitle)
    if (queryParams) {
      this.schoolName = queryParams.schoolName || "";
      this.selectSchoolId = queryParams.selectSchoolId || "";
      this.gradeName = queryParams.gradeName || "";
      this.selectGradeId = queryParams.selectGradeId || "";
      this.subjectName = queryParams.subjectName;
      this.selectSubjectId = queryParams.selectSubjectId;
      this.timeName = queryParams.timeName || "";
      this.selectTimeId = queryParams.selectTimeId || "";
      this.filterNum = queryParams.filterNum || "";
      this.activityId = queryParams.activityId || "";
      this.channelId = queryParams.channelId || "";
      this.selectNavString = queryParams.selectNavString || "";
      this.pageId = queryParams.pageId || "";
      if (queryParams.selectSchoolId === 0) {
        this.selectSchoolId = 0;
      }
      if (queryParams.selectGradeId === 0) {
        this.selectGradeId = 0;
      }
      if (queryParams.selectSubjectId === 0) {
        this.selectSubjectId = 0;
      }

      if (queryParams.selectTimeId === 0) {
        this.selectTimeId = 0;
      }
    }

    this.getRedis();
    // 打点数据
    gio("setPage", { activity_id: this.activityId });
    gio("setPage", { channel_id: this.channelId });
  },
  methods: {
    // 是否开启缓存
    getRedis() {
      getRedis().then((res) => {
        Indicator.close();
        console.log(res);
        let data = res;
        // 走缓存
        let params = this.getParams();
        let url;
        if (data === "1" || data === 1) {
          // 套餐
          if (Number(this.pageId) === 1) {
            url = `/newpackage?${params}`;
          } else if (Number(this.pageId) === 2) {
            // 单页
            url = `/newsingle/course?${params}`;
          } else if (Number(this.pageId) === 3) {
            // 报赠模式
            url = `/gift/course?${params}`;
          } else {
            // 默认单页
            url = `/newsingle/course?${params}`;
          }
        } else {
          if (Number(this.pageId) === 1) {
            url = `/package?${params}`;
          } else if (Number(this.pageId) === 4) {
            // 报赠模式 - 非缓存版本
            url = `/gift/course?${params}`;
          } else {
            url = `/single/list?${params}`;
          }
        }
        this.$router.push(url);
      });
    },
    // 获取跳转参数
    getParams() {
      let params =
        `activityId=${this.activityId}&channelId=${this.channelId}&schoolName=${this.schoolName}&gradeName=${this.gradeName}&timeName=${this.timeName}&subjectName=${this.subjectName}` +
        `&selectSchoolId=${this.selectSchoolId}&selectGradeId=${this.selectGradeId}&selectTimeId=${this.selectTimeId}&selectNavString=${this.selectNavString}&filterNum=${this.filterNum}&pageId=${this.pageId}`;
      return params;
    },
  },
};
</script>

<style lang="less" scoped>
</style>